var _path, _path2, _path3, _path4, _path5, _rect, _rect2, _rect3, _path6;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } } return target; }
import * as React from "react";
import { forwardRef } from "react";
var SvgCustomers = function SvgCustomers(_ref, ref) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19 20H5C3.343 20 2 18.657 2 17V5H19C20.657 5 22 6.343 22 8V17C22 18.657 20.657 20 19 20Z",
    fill: "#E3F2FD"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9 20C9 19.8845 9 19.7697 9 19.625C9 19.004 8.552 18.5 8 18.5C7.448 18.5 7 19.004 7 19.625C7 19.7697 7 19.8845 7 20L9 20Z",
    fill: "#90C9F9"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18 20C18 19.8845 18 19.7697 18 19.625C18 19.004 17.552 18.5 17 18.5C16.448 18.5 16 19.004 16 19.625C16 19.7697 16 19.8845 16 20L18 20Z",
    fill: "#90C9F9"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 11C8.60457 11 9.5 10.1046 9.5 9C9.5 7.89543 8.60457 7 7.5 7C6.39543 7 5.5 7.89543 5.5 9C5.5 10.1046 6.39543 11 7.5 11Z",
    fill: "#90C9F9"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M4 15.5C4 13.567 5.567 12 7.5 12C9.433 12 11 13.567 11 15.5V16H4V15.5Z",
    fill: "#90C9F9"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 10,
    width: 7,
    height: 1.5,
    rx: 0.75,
    fill: "#90C9F9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 12,
    width: 7,
    height: 1.5,
    rx: 0.75,
    fill: "#90C9F9"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 13,
    y: 14,
    width: 7,
    height: 1.5,
    rx: 0.75,
    fill: "#90C9F9"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M11 5H2V4C2 2.895 2.895 2 4 2H8.558C9.419 2 10.183 2.551 10.455 3.368L11 5Z",
    fill: "#90C9F9"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgCustomers);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "customers.f978233f18988aaec7c7de4571c82b55.svg";